import { type JSX } from 'react';
import { gql } from '@apollo/client';
import { graphql } from '@apollo/client/react/hoc';
import { Query } from '@apollo/client/react/components';

export interface IMeDatabase {
  id: string;
  name: string;
  roles: Array<{
    id: string;
    name: string;
  }>;
}

const meQuery = gql`
  query meQuery {
    me {
      sign
      name
      startedroutines {
        dbname
        routine
      }
      databases {
        id
        name
        roles {
          id
          name
        }
      }
    }
  }
`;

interface IRoles {
  id: string;
  name: string;
}

interface IDatabase {
  id: string;
  name: string;
  roles: IRoles[];
}

interface IMe {
  sign: string;
  name: string;
  databases: IDatabase[];
}

interface IResponse {
  me: IMe;
}

export interface IUser {
  sign: string;
  name: string;
}

interface IUserSignAndNameQueryProps {
  children: (
    loading: boolean,
    user: IUser | null,
    refetch: () => void
  ) => JSX.Element;
}

export const UserSignAndNameQuery = (props: IUserSignAndNameQueryProps) => (
  <Query<any> query={meQuery}>
    {({ loading, data, refetch }) => {
      let user: IUser | null = null;
      if (data && data.me) {
        user = {
          sign: data.me[0].sign,
          name: data.me[0].name,
        };
      }

      return props.children(loading, user, refetch);
    }}
  </Query>
);

export const withDatabases = (name: string) =>
  graphql<{}, IResponse, {}, {}>(meQuery, {
    props: ({ data }) => {
      if (data && data.me && data.me.databases) {
        return {
          [name]: data.me.databases,
          dbsLoading: data.loading,
        };
      }
      return {
        [name]: [],
        dbsLoading: data == null ? true : data.loading,
      };
    },
  });
